import { useLayoutEffect } from 'react'
import { useOutletContext } from 'react-router-dom'

export type FrameContext = {
  openRail: () => void
  /** Registers a mounted band Menu; returns its unregister. */
  registerBandMenu: () => () => void
}

const none: FrameContext = {
  openRail: () => {},
  registerBandMenu: () => () => {},
}

/** The frame's handle for pages under its Outlet (the console band's Menu). */
export function useFrame(): FrameContext {
  return useOutletContext<FrameContext | undefined>() ?? none
}

/** The caller renders the rail's Menu trigger in its band, so the frame hides
 *  its top bar while it is mounted; when it unmounts (a crash, a loading state)
 *  the top bar's Menu comes back, so a trigger always stays mounted (D82). */
export function useBandMenu() {
  const { registerBandMenu } = useFrame()
  useLayoutEffect(() => registerBandMenu(), [registerBandMenu])
}
